import { render, staticRenderFns } from "./EspeciesTabReferencias.vue?vue&type=template&id=34cd7e91&"
import script from "./EspeciesTabReferencias.vue?vue&type=script&lang=js&"
export * from "./EspeciesTabReferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports